export default "__VITE_ASSET__e7e5126b__"